<template>
    <FormItem :label="title">
        <div class="demo-upload-list" v-for="item in uploadList">
            <template v-if="item.status === 'finished'">
                <img :src="item.url|prepandImg">
                <div class="demo-upload-list-cover">
                    <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                    <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                </div>
            </template>
            <template v-else>
                <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
            </template>
        </div>
        <Upload
                ref="upload"
                :show-upload-list="false"
                :default-file-list="currentValue"
                :on-success="handleSuccess"
                :format="['jpg','jpeg','png']"
                :max-size="2048"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleBeforeUpload"
                multiple
                type="drag"
                :headers="{'x-token':$store.getters.token }"
                action="/supervise/admin/upload/uploadFile"
                style="display: inline-block;width:58px;">
            <div style="width: 58px;height:58px;line-height: 58px;">
                <Icon type="ios-camera" size="20"></Icon>
            </div>
        </Upload>
        <Modal title="图片预览" v-model="visible">
            <img :src="imgUrl|prepandImg" v-show="visible" style="width: 100%">
        </Modal>
    </FormItem>
</template>

<script>
    import mixins from './mixins'

    export default {
        name: "do-picture-list",
        mixins: [mixins],
        data() {
            return {
                currentValue: [],
                imgUrl: '',
                visible: false,
                uploadList: []
            }
        },
        methods: {
            setValue(val) {
                let parsedVal = val.map(e => e.url).join(',');
                if (this.value !== parsedVal) {
                    this.$emit('input', parsedVal);
                    this.$emit('on-change', parsedVal);
                }
            },
            // 屏蔽mixins级别监听事件
            setCurrentValue(val) {

            },
            // 图片预览
            handleView(url) {
                this.imgUrl = url;
                this.visible = true;
            },
            // 移除
            handleRemove(file) {
                this.$refs.upload.fileList.splice(this.$refs.upload.fileList.indexOf(file), 1);
                this.setValue(this.uploadList);
            },
            // 上传成功
            handleSuccess(res, file) {
                file.url = res.data.path;
                file.name = res.data.name;
                this.setValue(this.uploadList);
            },
            handleFormatError(file) {
                this.$Notice.warning({
                    title: '图片格式错误',
                    desc: '图片 ' + file.name + ' 格式错误, 请选择jpg,png格式的图片.'
                });
            },
            handleMaxSize(file) {
                this.$Notice.warning({
                    title: '尺寸错误',
                    desc: '图片  ' + file.name + ' 尺寸太大, 图片必须小于 2M.'
                });
            },
            handleBeforeUpload() {
                const check = this.uploadList.length < this.uploadMaxCount;
                if (!check) {
                    this.$Notice.warning({
                        title: '最多上传' + this.uploadMaxCount + '张图片.'
                    });
                }
                return check;
            }
        },
        mounted() {
            // 默认的图片上传列表
            let v = this.value ? this.value : '';
            v.split(',').filter(e => !!e).forEach((e, i) => {
                this.currentValue.push({name: i.toString(), url: e});
            });
            // 绑定图片上传列表
            this.$nextTick(() => {
                this.uploadList = this.$refs.upload.fileList;
            });
        },
        computed: {
            uploadMaxCount() {
                return this.options.uploadMaxCount || 6;
            }
        },
        filters:{
            prepandImg(url){
                if(url){
                    return '/supervise'+url
                }
                return null
            }
        }
    }
</script>

<style scoped>
    .demo-upload-list {
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
        margin-right: 4px;
    }

    .demo-upload-list img {
        width: 100%;
        height: 100%;
    }

    .demo-upload-list-cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, .6);
    }

    .demo-upload-list:hover .demo-upload-list-cover {
        display: block;
    }

    .demo-upload-list-cover i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
</style>
